<template>
  <div class="tariff-contract-offer">
    <Portal to="contract-offer-aside" slim :disabled="isSreenSizeGreaterThenMD">
      <div class="tariff-contract-offer__aside">
        <TableOfContents class="tariff-contract-offer__table-of-contents" />

        <MarginConfirmationBlock
          v-if="contractStatus != 'service' && contractStatus != 'terminated'"
          class="tariff-contract-offer__confirmation"
        />
      </div>
    </Portal>

    <div class="tariff-contract-offer__main">
      <StatusAndHistory class="tariff-contract-offer__status-and-history" />

      <PortalTarget name="contract-offer-aside" slim />

      <ContractOfferWrapper
        ref="contract-offer-wrapper"
        class="tariff-contract-offer__wrapper"
      />
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

import TableOfContents from "../../components/Tariff/TableOfContents.vue";
import MarginConfirmationBlock from "../../components/Tariff/MarginConfirmationBlock.vue";
import StatusAndHistory from "../../components/Tariff/StatusAndHistory.vue";
import ContractOfferWrapper from "../../components/Tariff/ContractOfferWrapper.vue";

export default {
  name: "TariffOffer",

  components: {
    TableOfContents,
    MarginConfirmationBlock,
    StatusAndHistory,
    ContractOfferWrapper,
  },

  inject: ["screenSize"],

  data() {
    return {
      parser: new DOMParser(),
      currentHTML: undefined,
    };
  },

  computed: {
    ...mapGetters("Organizations/ActiveOne", ["contractStatus"]),

    ...mapGetters({
      selectedFormId: "Organizations/ActiveOne/getOfferFormId",
    }),

    isSreenSizeGreaterThenMD() {
      return this.screenSize.greater("md").value;
    },
  },

  watch: {
    selectedFormId: {
      async handler(formId) {
        // wait until this component is mounted
        await this.$nextTick();

        if (!this.isSreenSizeGreaterThenMD) {
          this.$refs["contract-offer-wrapper"].$el.scrollIntoView({
            behavior: "smooth",
          });
        }

        this.selectOfferForm(formId);
      },

      immediate: true,
    },
  },

  methods: {
    ...mapActions({
      selectOfferForm: "Organizations/ActiveOne/selectOfferForm",
    }),
  },
};
</script>

<style scoped lang="scss">
.tariff-contract-offer {
  display: flex;
  padding: 12px 24px 24px;

  &__aside {
    position: sticky;
    top: 0;
    max-width: 280px;
    margin-right: 24px;
  }

  &__table-of-contents {
    width: 100%;
    margin-bottom: 16px;
  }

  &__confirmation {
    width: 100%;
  }

  &__main {
    width: calc(100% - 280px - 24px);
  }

  &__status-and-history {
    width: 100%;
    padding: 16px 30px;
    border-radius: 8px;
    margin-bottom: 30px;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.12);
  }

  &__wrapper {
    width: 100%;
    padding-bottom: 12px;
  }

  @media (max-width: 1264px) {
    &__aside {
      position: static;
      display: flex;
      max-width: 100%;
      justify-content: space-between;
      margin-right: 0;
    }

    &__table-of-contents {
      width: 60%;
      margin-right: 20px;

      &:only-child {
        width: 288px;
        margin-right: 0;
      }
    }

    &__confirmation {
      width: 38%;
      min-width: 240px;
    }

    &__main {
      width: 100%;
    }
  }

  @media (max-width: 960px) {
    &__status-and-history {
      padding: 16px;
    }
  }

  @media (max-width: 600px) {
    padding: 24px;

    &__aside {
      display: flex;
      max-width: 100%;
      flex-wrap: wrap;
      justify-content: space-between;
      margin-right: 0;
    }

    &__status-and-history {
      padding: 0;
      box-shadow: none;
    }

    &__table-of-contents,
    &__table-of-contents:only-child {
      width: 100%;
      margin-right: 0;
    }

    &__confirmation {
      width: 100%;
    }
  }
}
</style>
